import * as angular from "angular";
import {IController} from "angular";

export class cancellationReasonsTableRowCtrl implements IController {

  cancellationReason: any;
  onUpdateCancellationReason: Function;
  onDeleteCancellationReason: Function;

  /* @ngInject */
  constructor() {}

  $onInit() {
  }
}

angular
  .module('bringoz.admin.cancellation-reasons')
  .component('cancellationReasonsTableRow', {
    bindings: {
      cancellationReason: '<',
      onUpdateCancellationReason: '&',
      onDeleteCancellationReason: '&'
    },
    template: require('./cancellation-reasons-table-row.html').default,
    controller: cancellationReasonsTableRowCtrl
  });
